import Moment from "moment";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import convertUnicodeEmoji from "../../actions/convertUnicodeEmoji";
import {
  DetailsAnotationsida,
  DownloadFile,
  DetailsFileShared,
  dbfileSize,
} from "../../actions";
import WEBCHAT from "../../build/images/webchat.svg";
import WHATSAPP from "../../build/images/whatsapp-icon.svg";

const { connection_platform } = require("../../services/api");

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname !== connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  // if(parseInt(connection_platform.port_apache_view_extern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  // if(parseInt(connection_platform.port_apache_view_intern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}
let now = Moment().subtract(1, "month");
let dateinitsearchfile = now.format("YYYY-MM-DD");
let dateendsearchfile = Moment().format("YYYY-MM-DD");

let detailsFileShared = [];

export default function FileShareModal({ clientQueueMax }) {
  const [defaultValueFormat, setDefaultValueFormat] = useState("Todos");
  const [defaultValueMidias, setDefaultValueMidias] = useState("Todos");
  const [midias, setMidias] = useState(
    "2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18"
  );
  const [mimetypeids, setMimetypeids] = useState(
    "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18"
  );
  const [buttonShowFormatsFile, setButtonShowFormatsFile] = useState(false);
  const [buttonShowMidias, setButtonShowMidias] = useState(false);
  const [optionsActionsFile, setOptionsActionsFile] = useState([]);
  const filesSharedData = useSelector((state) => state.detailsfileshared);
  const dispatch = useDispatch();

  const ShowChoiceFormat = () => {
    setButtonShowFormatsFile(!buttonShowFormatsFile);
  };

  const choiceFormat = (event, formats, name) => {
    setMimetypeids(formats);
    setButtonShowFormatsFile(!buttonShowFormatsFile);
    setDefaultValueFormat(name);
  };

  const choiceMidia = (event, midias, name) => {
    setMidias(midias);
    setButtonShowMidias(!buttonShowMidias);
    setDefaultValueMidias(name);
  };

  const ShowChoiceMidias = () => {
    setButtonShowMidias(!buttonShowMidias);
  };

  const showExpandVisual = (idarq) => {
    var click = optionsActionsFile.indexOf(idarq) != -1 ? true : false;
    var temp = [];

    if (!click) {
      temp = optionsActionsFile.concat([idarq]);
    } else {
      temp = optionsActionsFile.filter(function (val) {
        return val != idarq;
      });
    }
    setOptionsActionsFile(temp);
  };

  const buttonSearchFileCompart = () => {
    var erro = 0;
    const datainit = document.getElementById("date_init_search_file").value;
    const datafim = document.getElementById("date_fim_search_file").value;
    const formats = mimetypeids;

    var comparation = Moment(datainit).isBefore(datafim);

    if (datainit === "") var erro = 1;

    if (datafim === "") var erro = 1;

    if (formats === "") var erro = 1;

    if (midias === "") var erro = 1;


    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      dispatch(
        DetailsFileShared(
          datainit,
          datafim,
          formats,
          midias,
          clientQueueMax[0].queueCaller
        )
      );
    }
  };

  if (filesSharedData.length != 0) {
    detailsFileShared = filesSharedData.detailsfileshared;
  }

  return (
    <div
      className="modal micromodal-slide"
      id="modal__arquivos-compartilhados_manager_new"
      aria-hidden="true"
      role="dialog"
    >
      <div className="modal__overlay" tabIndex="-1">
        <div
          className="modal__container"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__arquivos-compartilhados__title"
        >
          <header className="modal__header">
            <h2
              className="modal__title"
              id="modal__arquivos-compartilhados__title"
            >
              Arquivos compartilhados
            </h2>
            <button
              className="modal__close"
              aria-label="Close modal"
              data-micromodal-close
            ></button>
          </header>
          <main
            className="modal__content"
            id="modal__arquivos-compartilhados__content"
          >
            <div className="arq-comp__info">
              <p className="arq-comp__name  is-poppins">
                {clientQueueMax.length !== 0
                  ? clientQueueMax[0].queueContactname !== " "
                    ? convertUnicodeEmoji(clientQueueMax[0].queueContactname)
                    : clientQueueMax[0].queueCaller
                  : ""}
              </p>
              <i className="material-icons arq-comp__icon">insert_drive_file</i>{" "}
              <span className="arq-comp__info-text">
                Total de{" "}
                <span className="arq-comp__counter">
                  {detailsFileShared.length}
                </span>{" "}
                arquivo&#x28;s&#x29;
              </span>
            </div>
            <div className="arq-comp__sub-panel">
              <p className="arq-comp__text">
                Use os campos abaixo para filtrar a sua pesquisa
              </p>
              <div className="arq-comp__sub-panel__grid">
                <div className="arq-comp__time-panel">
                  <p className="arq-comp__text">Periodo:</p>
                  <div className="arq-comp__ctrls">
                    <span className="arq-comp__span ml-0">De:</span>
                    <input
                      type="date"
                      className="arq-comp__start"
                      id="date_init_search_file"
                      defaultValue={dateinitsearchfile}
                    />
                    <span className="arq-comp__span">Até:</span>
                    <input
                      type="date"
                      className="arq-comp__end"
                      id="date_fim_search_file"
                      defaultValue={dateendsearchfile}
                    />
                  </div>
                </div>
                <div className="arq-comp__format-panel">
                  <p className="arq-comp__text">Formato:</p>
                  <div style={{ display: "none" }}>
                    <input
                      type="text"
                      defaultValue={"3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18"}
                      //   ref={input => (this.mimetypeids = input)}
                      className="mimetype"
                    />
                    <input
                      type="text"
                      defaultValue={"2,4,5"}
                      //   ref={input => (this.midias = input)}
                      className="midias"
                    />
                  </div>
                  <div className="arq-comp__ctrls">
                    <button
                      type="date"
                      className="arq-comp__format-btn"
                      onClick={() => ShowChoiceFormat()}
                    >
                      {defaultValueFormat}{" "}
                      <span className="material-icons">expand_more</span>
                    </button>
                    <ul
                      className={
                        buttonShowFormatsFile
                          ? "arq-comp__list arq-comp__format-list active"
                          : "arq-comp__list arq-comp__format-list"
                      }
                    >
                      <li
                        className="arq-comp__item"
                        onClick={(event) =>
                          choiceFormat(
                            event,
                            "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18",
                            "Todos"
                          )
                        }
                      >
                        <span className="arq-comp__radio"></span> Todos
                      </li>
                      <li
                        className="arq-comp__item"
                        onClick={(event) => choiceFormat(event, "5", "PDF")}
                      >
                        <span className="arq-comp__radio"></span> PDF
                      </li>
                      <li
                        className="arq-comp__item"
                        onClick={(event) =>
                          choiceFormat(event, "10,11,14", "DOC")
                        }
                      >
                        <span className="arq-comp__radio"></span> DOC
                      </li>
                      <li
                        className="arq-comp__item"
                        onClick={(event) => choiceFormat(event, "8,9", "XLS")}
                      >
                        <span className="arq-comp__radio"></span> XLS
                      </li>
                      <li
                        className="arq-comp__item"
                        onClick={(event) => choiceFormat(event, "12,13", "PPT")}
                      >
                        <span className="arq-comp__radio"></span> PPT
                      </li>
                      <li
                        className="arq-comp__item"
                        onClick={(event) => choiceFormat(event, "7", "ZIP")}
                      >
                        <span className="arq-comp__radio"></span> ZIP
                      </li>
                      <li
                        className="arq-comp__item"
                        onClick={(event) =>
                          choiceFormat(event, "3,18", "Imagem")
                        }
                      >
                        <span className="arq-comp__radio"></span> Imagem
                      </li>
                      <li
                        className="arq-comp__item"
                        onClick={(event) =>
                          choiceFormat(event, "4,6,15,17", "Áudio")
                        }
                      >
                        <span className="arq-comp__radio"></span> Áudio
                      </li>
                      <li
                        className="arq-comp__item"
                        onClick={(event) => choiceFormat(event, "16", "Vídeo")}
                      >
                        <span className="arq-comp__radio"></span> Vídeo
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="arq-comp__channel-panel">
                  <p className="arq-comp__text">Canal:</p>
                  <div className="arq-comp__ctrls">
                    <button
                      type="date"
                      onClick={() => ShowChoiceMidias()}
                      className="arq-comp__channel-btn"
                    >
                      {defaultValueMidias}{" "}
                      <span className="material-icons">expand_more</span>
                    </button>
                    <ul
                      className={
                        buttonShowMidias
                          ? "arq-comp__list arq-comp__format-list active"
                          : "arq-comp__list arq-comp__format-list"
                      }
                    >
                      <li
                        className="arq-comp__item"
                        id="Todos"
                        onClick={(event) =>
                          choiceMidia(event, "5,4,2", "Todos")
                        }
                      >
                        <span id="Todos" className="arq-comp__radio"></span>{" "}
                        Todos
                      </li>
                      <li
                        className="arq-comp__item"
                        id="Whatsapp"
                        onClick={(event) => choiceMidia(event, "5", "Whatsapp")}
                      >
                        <span id="Whatsapp" className="arq-comp__radio"></span>{" "}
                        Whatsapp
                      </li>
                      <li
                        className="arq-comp__item"
                        id="Facebook"
                        onClick={(event) => choiceMidia(event, "4", "Facebook")}
                      >
                        <span id="Facebook" className="arq-comp__radio"></span>{" "}
                        Facebook
                      </li>
                      <li
                        className="arq-comp__item"
                        id="Webchat"
                        onClick={(event) => choiceMidia(event, "2", "Webchat")}
                      >
                        <span id="Webchat" className="arq-comp__radio"></span>{" "}
                        Webchat
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="arq-comp__ctrls">
                  <button
                    className="arq-comp__search-btn"
                    onClick={(event) => buttonSearchFileCompart(event)}
                  >
                    Filtrar
                  </button>
                </div>
              </div>

              <div className="arq-comp__content">
                <div className="arq-comp__table">
                  <div className="arq-comp__t-head">
                    <div className="arq-comp__t-col1 sort-by__btn">
                      <i className="material-icons">sort_by_alpha</i>
                    </div>
                    <div className="arq-comp__t-col2">Nome:</div>
                    <div className="arq-comp__t-col3">Data:</div>
                    <div className="arq-comp__t-col4">Tamanho:</div>
                    <div className="arq-comp__t-col5">Canal:</div>
                  </div>
                  <div className="arq-comp__t-body">
                    {detailsFileShared.map((dfilesh) => (
                      <div
                        className="arq-comp__t-item"
                        id="01"
                        key={dfilesh.id}
                        onClick={() => showExpandVisual(dfilesh.id)}
                      >
                        <div
                          className={
                            optionsActionsFile.indexOf(dfilesh.id) != -1
                              ? "arq-comp__t-item__context id-01 active"
                              : "arq-comp__t-item__context id-01"
                          }
                        >
                          <div className="context__label special">
                            <a
                              className="context__content"
                              href={
                                connection_platform.type_connect +
                                "://" +
                                ipcurrent +
                                dfilesh.mensagem
                              }
                              target="_blank"
                              download
                            >
                              <span className="material-icons">visibility</span>
                              <span className="context__text">Visualizar</span>
                            </a>
                          </div>
                          <div className="context__label">
                            <div
                              className="context__content"
                              onClick={() =>
                                dispatch(
                                  DownloadFile(
                                    connection_platform.type_connect +
                                      "://" +
                                      ipcurrent +
                                      dfilesh.mensagem,
                                    dfilesh.mensagem
                                  )
                                )
                              }
                            >
                              <span className="material-icons">get_app</span>
                              <span className="context__text">
                                Fazer download
                              </span>
                            </div>
                          </div>
                          {/* <div className="context__label">
                                <div className="context__content">
                                  <span className="material-icons">email</span>
                                  <span className="context__text">
                                    Enviar por email
                                  </span>
                                </div>
                              </div> */}
                        </div>
                        <div className="arq-comp__t-sort">
                          <span className="arq-comp__t-sort_ft">
                            {dfilesh.formato}
                          </span>
                        </div>
                        <div className="arq-comp__t-name">
                          Arquivo em {dfilesh.formato}
                        </div>
                        <div className="arq-comp__t-date">
                          {dfilesh.data_envio}
                        </div>
                        {(() => {
                          var url =
                            connection_platform.type_connect +
                            "://" +
                            ipcurrent +
                            dfilesh.mensagem;
                          {
                            dbfileSize(dfilesh.filesize);
                          }
                        })()}
                        <div className="arq-comp__t-size">
                          {dbfileSize(dfilesh.filesize)}
                        </div>
                        <div className="arq-comp__t-channel">
                          {(() => {
                            if (dfilesh.idmidia === 5) {
                              return (
                                <img
                                  src={WHATSAPP}
                                  alt=""
                                  className="arq-comp__t-channel__icon"
                                />
                              );
                            } else if (dfilesh.idmidia === 4) {
                              return (
                                <img
                                  src="build/images/t-facebook.svg"
                                  alt=""
                                  className="arq-comp__t-channel__icon"
                                />
                              );
                            } else if (dfilesh.idmidia === 2) {
                              return (
                                <img
                                  src={WEBCHAT}
                                  alt=""
                                  className="arq-comp__t-channel__icon"
                                />
                              );
                            }
                          })()}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
